[data-arkme-reaction-preview] .arkme-reaction-hover-trigger {
  opacity: 0;
  pointer-events: none;
}
[data-arkme-reaction-preview]:hover .arkme-reaction-hover-trigger,
[data-arkme-reaction-preview]:has(:focus-visible) .arkme-reaction-hover-trigger,
[data-arkme-reaction-preview][data-open="true"] .arkme-reaction-hover-trigger {
  opacity: 1;
  pointer-events: auto;
}
@media (hover: none) {
  [data-arkme-reaction-preview] .arkme-reaction-hover-trigger {
    opacity: 1;
    pointer-events: auto;
  }
}

.arkme-day-message[aria-current=true] { position: relative; }
.arkme-day-message[aria-current=true]::before { content: ''; position: absolute; left: -10px; top: 0; bottom: 0; width: 2px; background: var(--day-accent); pointer-events: none; }
.arkme-reaction-cancelled { opacity: .6; position: relative; display: inline-block; vertical-align: baseline; text-decoration: none; }
.arkme-reaction-cancelled::after { content: ''; position: absolute; inset-inline: 0; top: 50%; border-top: 1px solid currentColor; pointer-events: none; z-index: 1; }

.arkme-reaction-phrase-input:focus { outline: 1px solid #9299a3 !important; outline-offset: 0; box-shadow: none !important; }

.arkme-saved-phrase-delete { opacity: 0; pointer-events: none; }
.arkme-saved-phrase:hover .arkme-saved-phrase-delete,
.arkme-saved-phrase:has(:focus-visible) .arkme-saved-phrase-delete { opacity: 1; pointer-events: auto; }
.arkme-saved-phrase-delete,
.arkme-saved-phrase-delete:hover,
.arkme-saved-phrase-delete:active,
.arkme-saved-phrase-delete:focus {
  background: transparent !important;
  box-shadow: none !important;
  filter: none;
}
.arkme-saved-phrase-delete:not(:focus-visible) { outline: none !important; }
.arkme-saved-phrase-delete::before, .arkme-saved-phrase-delete::after { display: none; }
.arkme-saved-phrase-delete > span { opacity: .65; transition: opacity 120ms ease; }
.arkme-saved-phrase-delete:hover > span, .arkme-saved-phrase-delete:focus-visible > span { opacity: 1; }
.arkme-saved-phrase-delete:focus-visible { outline: 1px solid #9299a3; outline-offset: 1px; }
@media (hover: none) {
  .arkme-saved-phrase-delete { opacity: 1; pointer-events: auto; }
}

.arkme-reaction-phrase-button:not(:focus-visible) {
  outline: none !important;
  box-shadow: none !important;
}
.arkme-reaction-phrase-button:focus-visible {
  outline: 1px solid #9299a3;
  outline-offset: 2px;
}
.arkme-phrase-delete-reveal {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  background: #ee581c;
  color: white;
  border-radius: inherit;
  pointer-events: none;
  animation: arkme-phrase-delete-expand 240ms cubic-bezier(.2,.75,.25,1) both;
}
.arkme-phrase-delete-reveal > span {
  animation: arkme-phrase-delete-caption 180ms ease-out 60ms both;
}
@keyframes arkme-phrase-delete-expand {
  from { clip-path: inset(0 0 100% 100% round 7px); }
  to { clip-path: inset(0 0 0 0 round 7px); }
}
@keyframes arkme-phrase-delete-caption {
  from { opacity: 0; transform: translate(3px, -2px); }
  to { opacity: 1; transform: translate(0, 0); }
}
@media (prefers-reduced-motion: reduce) {
  .arkme-phrase-delete-reveal, .arkme-phrase-delete-reveal > span { animation: none; }
}
.arkme-reaction-phrase-dialog::backdrop {
  background: rgba(0, 0, 0, .2);
}

@keyframes arkme-reaction-highlight {
  0%, 75% { opacity: 1; }
  100% { opacity: 0; }
}
@media (prefers-reduced-motion: reduce) {
  [data-arkme-highlight-backdrop] { animation: none !important; }
}

.arkme-new-reaction { animation: arkme-new-reaction 2.3s ease-in-out both; border-radius: 4px; }
@keyframes arkme-new-reaction {
  0%, 100% { box-shadow: inset 0 0 0 100px rgba(38, 49, 72, 0); }
  8.6957%, 47.8261% { box-shadow: inset 0 0 0 100px rgba(38, 49, 72, .16); }
}
@media (prefers-reduced-motion: reduce) {
  .arkme-new-reaction { animation: none; box-shadow: inset 0 0 0 100px rgba(38, 49, 72, .16); }
}
